<template>
    <div class="min-h-screen bg-gray-50 py-8">
        <!-- 面包屑导航 -->
        <div class="breadcrumb-container">
            <el-breadcrumb separator=">">
                <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
                <el-breadcrumb-item :to="{ path: '/registration' }">数据登记</el-breadcrumb-item>
                <el-breadcrumb-item>常见问题</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
            <!-- 页面标题 -->
            <div class="text-center mb-12">
                <h1 class="text-4xl font-bold text-gray-900 mb-4">常见问题解答</h1>
                <p class="text-lg text-gray-600 max-w-3xl mx-auto">
                    在这里您可以找到网站登记过程中常见问题的解答。如果找不到您需要的答案，请联系我们的客服团队。
                </p>
            </div>

            <!-- 搜索框 -->
            <div class="max-w-2xl mx-auto mb-12">
                <div class="relative">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <span class="iconify text-gray-400" data-icon="ri:search-line"></span>
                    </div>
                    <input v-model="searchQuery" type="text" placeholder="搜索问题或关键词..."
                        class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#00BFA5] focus:border-transparent" />
                    <div v-if="searchQuery" class="absolute inset-y-0 right-0 pr-3 flex items-center">
                        <button @click="searchQuery = ''" class="text-gray-400 hover:text-gray-600">
                            <span class="iconify" data-icon="ri:close-line"></span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- 分类导航 -->
            <div class="mb-12">
                <div class="flex flex-wrap justify-center gap-4">
                    <button v-for="category in categories" :key="category.id" @click="activeCategory = category.id"
                        :class="[
                            'px-6 py-3 rounded-full font-medium transition-all duration-200',
                            activeCategory === category.id
                                ? 'bg-[#00BFA5] text-white shadow-md'
                                : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
                        ]">
                        {{ category.name }}
                        <span class="ml-2 text-sm opacity-80">
                            ({{ category.count }})
                        </span>
                    </button>
                </div>
            </div>

            <!-- 常见问题列表 -->
            <div class="space-y-6">
                <div v-for="faq in filteredFAQs" :key="faq.id"
                    class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                    <button @click="toggleFAQ(faq.id)"
                        class="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors">
                        <div class="flex items-start space-x-4">
                            <div class="flex-shrink-0 mt-1">
                                <span class="iconify text-[#00BFA5] text-xl" data-icon="ri:question-line"></span>
                            </div>
                            <div class="flex-1">
                                <h3 class="text-lg font-semibold text-gray-900 mb-1">
                                    {{ faq.question }}
                                </h3>
                                <div class="flex items-center space-x-4 text-sm text-gray-500">
                                    <span class="flex items-center">
                                        <span class="iconify mr-1" data-icon="ri:folder-line"></span>
                                        {{ faq.category }}
                                    </span>
                                    <span class="flex items-center">
                                        <span class="iconify mr-1" data-icon="ri:time-line"></span>
                                        更新于 {{ faq.updatedAt }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <span class="iconify text-gray-400 text-2xl transition-transform duration-200"
                            :class="{ 'rotate-180': expandedFAQs.includes(faq.id) }"
                            data-icon="ri:arrow-down-s-line"></span>
                    </button>

                    <!-- 答案内容 -->
                    <div v-if="expandedFAQs.includes(faq.id)" class="px-6 py-5 bg-gray-50 border-t border-gray-200">
                        <div class="prose prose-green max-w-none">
                            <div v-html="faq.answer"></div>

                            <!-- 相关链接 -->
                            <div v-if="faq.relatedLinks && faq.relatedLinks.length" class="mt-6">
                                <h4 class="font-semibold text-gray-900 mb-3">相关链接</h4>
                                <div class="space-y-2">
                                    <a v-for="link in faq.relatedLinks" :key="link.text" :href="link.url"
                                        class="flex items-center text-[#00BFA5] hover:text-[#009688] hover:underline">
                                        <span class="iconify mr-2" data-icon="ri:external-link-line"></span>
                                        {{ link.text }}
                                    </a>
                                </div>
                            </div>
                        </div>

                        <!-- 有用性反馈 -->
                        <!-- <div class="mt-6 pt-6 border-t border-gray-200">
                            <p class="text-sm text-gray-600 mb-3">这个回答对您有帮助吗？</p>
                            <div class="flex items-center space-x-4">
                                <button @click="voteHelpful(faq.id)"
                                    class="flex items-center px-4 py-2 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 transition-colors">
                                    <span class="iconify mr-2" data-icon="ri:thumb-up-line"></span>
                                    有帮助
                                </button>
                                <button @click="voteNotHelpful(faq.id)"
                                    class="flex items-center px-4 py-2 bg-red-50 text-red-700 rounded-lg hover:bg-red-100 transition-colors">
                                    <span class="iconify mr-2" data-icon="ri:thumb-down-line"></span>
                                    没有帮助
                                </button>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>

            <!-- 没有搜索结果 -->
            <div v-if="filteredFAQs.length === 0" class="text-center py-12">
                <div class="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <span class="iconify text-gray-400 text-4xl" data-icon="ri:search-line"></span>
                </div>
                <h3 class="text-xl font-semibold text-gray-900 mb-2">未找到相关问题</h3>
                <p class="text-gray-600 mb-6">尝试使用其他关键词搜索，或联系我们的客服团队获取帮助。</p>
                <button @click="searchQuery = ''"
                    class="px-6 py-3 bg-[#00BFA5] text-white rounded-lg hover:bg-[#009688] transition-colors">
                    查看所有问题
                </button>
            </div>

            <!-- 联系客服 -->
            <div class="mt-16 bg-gradient-to-r from-green-50 to-blue-50 rounded-2xl p-8">
                <div class="max-w-3xl mx-auto text-center">
                    <h2 class="text-2xl font-bold text-gray-900 mb-4">仍然需要帮助？</h2>
                    <p class="text-gray-600 mb-6">
                        如果我们的常见问题解答没有解决您的问题请
                        <a href="/about" class="text-blue-600 hover:underline">联系我们</a>
                        ，我们的客服团队随时为您提供帮助。
                    </p>
                    <!-- <div class="flex flex-col sm:flex-row gap-4 justify-center">
                        <a href="mailto:support@example.com"
                            class="px-6 py-3 bg-[#00BFA5] text-white rounded-lg hover:bg-[#009688] transition-colors inline-flex items-center justify-center">
                            <span class="iconify mr-2" data-icon="ri:mail-line"></span>
                            发送邮件
                        </a>
                        <a href="tel:+861234567890"
                            class="px-6 py-3 bg-white text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors inline-flex items-center justify-center">
                            <span class="iconify mr-2" data-icon="ri:phone-line"></span>
                            电话联系
                        </a>
                        <button @click="openLiveChat"
                            class="px-6 py-3 bg-white text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors inline-flex items-center justify-center">
                            <span class="iconify mr-2" data-icon="ri:chat-3-line"></span>
                            在线客服
                        </button>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'

const searchQuery = ref('')
const activeCategory = ref('all')
const expandedFAQs = ref([])

// 分类数据
const categories = ref([
    { id: 'all', name: '全部问题', count: 12 },
    { id: 'registration', name: '登记流程', count: 5 },
    { id: 'verification', name: '验证审核', count: 3 },
    { id: 'documents', name: '文件要求', count: 2 },
    { id: 'technical', name: '技术问题', count: 2 },
])

// 页面加载时滚动到顶部
onMounted(() => {
    // 确保页面加载时滚动到顶部
    window.scrollTo({ top: 0, behavior: 'smooth' })

    // 展开第一个问题
    if (faqs.value.length > 0) {
        expandedFAQs.value.push(faqs.value[0].id)
    }
})


// 常见问题数据
const faqs = ref([

    {
        id: 2,
        question: '登记审核需要多长时间？',
        answer: `
      <p>审核时间根据具体情况有所不同：</p>
      <ol>
        <li><strong>初审</strong>：1-3个工作日</li>
        <li><strong>复审</strong>：3-5个工作日</li>
        <li><strong>终审</strong>：5-7个工作日</li>
      </ol>
      <p class="mt-4">如果材料齐全且符合要求，整个流程通常需要7-15个工作日。您可以在个人中心查看审核进度。</p>
    `,
        category: '验证审核',
        updatedAt: '2024-01-10',
        relatedLinks: [
            { text: '审核进度查询', url: '/DataProperty' }
        ]
    },
    {
        id: 3,
        question: '如何修改已提交的登记信息？',
        answer: `
      <p>在审核通过前，您可以随时修改已提交的信息：</p>
      <ol>
        <li>登录您的账户</li>
        <li>进入"我的登记"页面</li>
        <li>找到需要修改的登记记录</li>
        <li>点击"编辑"按钮进行修改</li>
        <li>重新提交审核</li>
      </ol>
      <p class="mt-4 text-sm text-red-600">注意：审核通过后，如需修改信息需要重新提交变更申请。</p>
    `,
        category: '登记流程',
        updatedAt: '2024-01-12',
        relatedLinks: []
    },
    {
        id: 4,
        question: '网站备案号在哪里查看？',
        answer: `
      <p>备案号可以通过以下方式查看：</p>
      <ul>
        <li><strong>个人中心</strong>：登录后在"我的备案"页面查看</li>
        <li><strong>邮件通知</strong>：审核通过后会发送包含备案号的邮件</li>
        <li><strong>网站底部</strong>：备案号需展示在网站首页底部</li>
      </ul>
      <p class="mt-4">备案号格式通常为：省简称+ICP备+XXXXXXXX号</p>
    `,
        category: '验证审核',
        updatedAt: '2024-01-08',
        relatedLinks: [

        ]
    },
    {
        id: 5,
        question: '支持哪些文件格式上传？',
        answer: `
      <p>系统支持以下文件格式：</p>
      <div class="grid grid-cols-2 gap-4 mt-4">
        <div class="bg-gray-50 p-3 rounded-lg">
          <div class="font-semibold text-gray-900">图片文件</div>
          <div class="text-sm text-gray-600">JPG, PNG, GIF, PDF</div>
        </div>
        <div class="bg-gray-50 p-3 rounded-lg">
          <div class="font-semibold text-gray-900">文档文件</div>
          <div class="text-sm text-gray-600">DOC, DOCX, PDF</div>
        </div>
      </div>
      <p class="mt-4 text-sm text-gray-600">单个文件大小不超过10MB，建议使用PDF格式以保证文件质量。</p>
    `,
        category: '文件要求',
        updatedAt: '2024-01-05',
        relatedLinks: []
    },
    {
        id: 6,
        question: '忘记登录密码怎么办？',
        answer: `
      <p>如果您忘记了登录密码，可以通过以下方式重置：</p>
      <ol>
        <li>在登录页面点击"忘记密码"</li>
        <li>输入注册时使用的邮箱或手机号</li>
        <li>查收验证码邮件或短信</li>
        <li>输入验证码并设置新密码</li>
      </ol>
      <p class="mt-4">如果无法收到验证码，请联系客服协助处理。</p>
    `,
        category: '技术问题',
        updatedAt: '2024-01-03',
        relatedLinks: [
            { text: '密码重置页面', url: '/PassWord' }
        ]
    }
])

// 计算过滤后的FAQ
const filteredFAQs = computed(() => {
    let filtered = faqs.value

    // 按分类过滤
    if (activeCategory.value !== 'all') {
        filtered = filtered.filter(faq => faq.category === categories.value.find(c => c.id === activeCategory.value)?.name)
    }

    // 按搜索词过滤
    if (searchQuery.value) {
        const query = searchQuery.value.toLowerCase()
        filtered = filtered.filter(faq =>
            faq.question.toLowerCase().includes(query) ||
            faq.answer.toLowerCase().includes(query) ||
            faq.category.toLowerCase().includes(query)
        )
    }

    return filtered
})

// 切换FAQ展开状态
const toggleFAQ = (id) => {
    const index = expandedFAQs.value.indexOf(id)
    if (index > -1) {
        expandedFAQs.value.splice(index, 1)
    } else {
        expandedFAQs.value.push(id)
    }
}

// 投票功能
const voteHelpful = (id) => {
    alert(`感谢您的反馈！问题 #${id} 标记为有帮助。`)
}

const voteNotHelpful = (id) => {
    alert(`感谢您的反馈！我们将改进问题 #${id} 的解答。`)
}

// 打开在线客服
const openLiveChat = () => {
    alert('在线客服功能即将开放，敬请期待！')
}

// 页面加载时展开第一个问题
onMounted(() => {
    if (faqs.value.length > 0) {
        expandedFAQs.value.push(faqs.value[0].id)
    }
})
</script>

<style scoped>
.rotate-180 {
    transform: rotate(180deg);
}

.prose {
    color: #374151;
}

.prose ul {
    list-style-type: disc;
    padding-left: 1.5em;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
}

.prose ol {
    list-style-type: decimal;
    padding-left: 1.5em;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
}

.prose li {
    margin-bottom: 0.25em;
}

.prose p {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
}

/* 面包屑导航样式 */
.breadcrumb-container {
    background-color: #ffffff00;
    padding: 15px 5%;
    border-bottom: 1px solid #e0e0e0;
}

.breadcrumb-container>>>.el-breadcrumb {
    font-size: 14px;
    max-width: 1200px;
    margin: 0 auto;
}

.breadcrumb-container>>>.el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: #1E88E5;
    font-weight: 500;
}

.breadcrumb-container>>>.el-breadcrumb__separator {
    margin: 0 8px;
    color: #999;
}

/* 响应式布局 */
@media (max-width: 768px) {
    .breadcrumb-container {
        padding: 10px 5%;
    }

    .breadcrumb-container>>>.el-breadcrumb {
        font-size: 12px;
    }

    .asset-detail {
        min-width: 100vw;
        font-size: 16px;
        touch-action: pinch-zoom;
        -webkit-text-size-adjust: none;
        overflow-x: auto;
        transform-origin: 0 0;
    }
}
</style>